import {
  UiSize,
  UiFontSize,
  UiRounded,
  UiShadow,
  UiShadowColor,
  UiVariant,
  UiColor,
  UiBorderWidth,
  UiLineHeight,
  UiLetterSpacing,
  UiTransition,
  UiBackgroundColor,
} from "./ui";

export const defaultUiConfig = {
  size: { mob: UiSize.xs, tab: UiSize.sm, web: UiSize.md },
  fontSize: { mob: UiFontSize.xs, tab: UiFontSize.sm, web: UiFontSize.md },
  rounded: { mob: UiRounded.sm, tab: UiRounded.sm, web: UiRounded.sm },
  shadow: { mob: UiShadow.none, tab: UiShadow.none, web: UiShadow.none },
  shadowColor: {
    mob: UiShadowColor.none,
    tab: UiShadowColor.none,
    web: UiShadowColor.none,
  },
  padding: { mob: "0", tab: "0", web: "0" },
  margin: { mob: "0", tab: "0", web: "0" },
  variant: UiVariant.solid,
  colorPalette: UiColor.gray,
  backgroundColor: UiBackgroundColor.transparent,
  borderWidth: UiBorderWidth.none,
  lineHeight: UiLineHeight.base,
  letterSpacing: UiLetterSpacing.normal,
  transition: UiTransition.normal,
};
